import { LinkButton, vars } from '@etg/wings';
import { css, mediaQueries } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { SEATING_PREFERENCE_OPTIONS, SEATING_PREFERENCE_VALUES } from '../../../utils/constants';
import PriceCell from './SummaryPriceCell';
import ActionsCell from './SummaryActionsCell';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const rowStyles = css`
  font-size: 0.875rem;
  position: relative;
  width: 100%;

  @media ${mediaQueries.small.only} {
    border-top: 1px solid #dedede;
    display: flex;
    flex-direction: column;
    padding: 0.5rem 0;
  }

  & > * {
    vertical-align: middle;
  }
`;
const unavailableRowStyles = css`
  font-size: 0.875rem;

  @media ${mediaQueries.small.only} {
    border-top: 1px solid ${vars.colors.inputs.border};
    display: flex;
    padding: 0.5rem 0;
  }

  & > * {
    vertical-align: middle;
  }
`;
const cellStyles = css`
  align-items: baseline;
  display: table-cell;
  font-size: 0.75rem;

  @media ${mediaQueries.small.only} {
    display: contents;
    margin-left: 2.25rem;

    html[dir='rtl'] & {
      margin-left: 0;
      margin-right: 2.25rem;
    }
  }

  @media ${mediaQueries.medium.up} {
    font-size: 0.875rem;
  }

  & div {
    width: 50%;
    html[dir='rtl'] & {
      text-align: right;
    }
  }
`;
const unavailableCellStyles = css`
  color: ${vars.colors.decoration.neutral};
  font-size: 0.625rem;
  padding: 0.625rem;
  text-align: center;

  @media ${mediaQueries.medium.down} {
    flex: 1;
    font-size: 0.75rem;
    padding: 0.875rem;
  }

  @media ${mediaQueries.medium.up} {
    font-size: 0.875rem;
  }
`;
const SummaryUnavailableRow = _ref => {
  var _selected$;
  let {
    onRemoveOption,
    onToggleOptionSelect,
    boundIndex,
    segmentIndex,
    selected,
    type
  } = _ref;
  const {
    t
  } = useTranslation();
  const [selectedOption] = selected || [];
  const seatPreference = (_selected$ = selected[0]) === null || _selected$ === void 0 ? void 0 : _selected$.seatPreference;
  const getTextForType = optionType => {
    switch (optionType) {
      case SEATING_PREFERENCE_VALUES.AISLE:
        return t('Product.SeatMap.Segment.Unavailable.SeatingCombo.Values.Aisle.Content');
      case SEATING_PREFERENCE_VALUES.WINDOW:
        return t('Product.SeatMap.Segment.Unavailable.SeatingCombo.Values.Window.Content');
      case SEATING_PREFERENCE_VALUES.BESIDE:
        return t('Product.SeatMap.Segment.Unavailable.SeatingCombo.Values.Beside.Content');
      case SEATING_PREFERENCE_VALUES.NO_OPTION:
        return t('Product.SeatMap.Segment.Unavailable.SeatingCombo.Values.AnySeat.Content');
      default:
        return t('Product.SeatMap.Summary.Segment.Unavailable');
    }
  };
  const isSeatingLightOrBesideAvailable = type === SEATING_PREFERENCE_OPTIONS.SELL_SEATING_BESIDE || type === SEATING_PREFERENCE_OPTIONS.SELL_SEATING_PREFERENCE;
  if (!isSeatingLightOrBesideAvailable) {
    return /*#__PURE__*/_jsx("tr", {
      className: unavailableRowStyles,
      children: /*#__PURE__*/_jsx("td", {
        className: unavailableCellStyles,
        colSpan: 5,
        children: t('Product.SeatMap.Summary.Segment.Unavailable')
      })
    });
  }
  if (isSeatingLightOrBesideAvailable && seatPreference === SEATING_PREFERENCE_VALUES.NO_OPTION) {
    return /*#__PURE__*/_jsx("tr", {
      className: unavailableRowStyles,
      children: /*#__PURE__*/_jsxs("td", {
        className: unavailableCellStyles,
        colSpan: 5,
        children: [t('Product.SeatMap.Segment.Unavailable.SeatingCombo.Values.AnySeat.Content'), ` `, /*#__PURE__*/_jsx(LinkButton, {
          onClick: onToggleOptionSelect,
          children: t('Product.SeatMap.Summary.Segment.Unavailable.Cta.Label')
        })]
      })
    });
  }
  if (isSeatingLightOrBesideAvailable && selectedOption && selectedOption.seatPreference) {
    return /*#__PURE__*/_jsxs("tr", {
      className: rowStyles,
      children: [/*#__PURE__*/_jsx("td", {
        className: cellStyles,
        colSpan: 3,
        children: /*#__PURE__*/_jsx("div", {
          children: getTextForType(selectedOption.seatPreference)
        })
      }), /*#__PURE__*/_jsx(PriceCell, {
        markup: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.markup,
        markupTooltipId: `row_${boundIndex}_${segmentIndex}_0`,
        seatPrice: selectedOption.price
      }), /*#__PURE__*/_jsx(ActionsCell, {
        boundIndex: boundIndex,
        onRemoveSeat: onRemoveOption,
        onToggleSeatSelect: onToggleOptionSelect,
        segmentIndex: segmentIndex,
        selectedSeat: selectedOption,
        travelerIndex: 0
      })]
    });
  }
  return /*#__PURE__*/_jsx("tr", {
    className: unavailableRowStyles,
    children: /*#__PURE__*/_jsxs("td", {
      className: unavailableCellStyles,
      colSpan: 5,
      children: [t('Product.SeatMap.Summary.Segment.Unavailable'), ` `, /*#__PURE__*/_jsx(LinkButton, {
        onClick: onToggleOptionSelect,
        children: t('Product.SeatMap.Segment.Unavailable.SeatingCombo.Values.AnySeat.Content')
      })]
    })
  });
};
export default SummaryUnavailableRow;
//# sourceMappingURL=SummaryUnavailableRow.js.map